export default __webpack_public_path__ + "static/media/pwaApLogo.19205981.png";